var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "zone-v2" },
          [
            _c(
              "el-dialog",
              {
                staticClass: "responsive",
                attrs: {
                  visible: _vm.insertZoneModal,
                  title: _vm.$t("zone.insertZone"),
                  width: "50%",
                  top: "30vh",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.insertZoneModal = $event
                  },
                },
              },
              [
                _vm.insertZoneModal
                  ? _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "left",
                          "label-width": "8em",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.projectCode") } },
                          [
                            _c("el-input", {
                              staticClass: "uppercase",
                              attrs: {
                                type: "text",
                                id: "projectCode",
                                name: "projectCode",
                                disabled: true,
                              },
                              model: {
                                value: _vm.projectCodeId,
                                callback: function ($$v) {
                                  _vm.projectCodeId = $$v
                                },
                                expression: "projectCodeId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.code") } },
                          [
                            _c("el-input", {
                              staticClass: "uppercase",
                              attrs: { type: "text", id: "code", name: "code" },
                              model: {
                                value: _vm.formData.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "code", $$v)
                                },
                                expression: "formData.code",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.name") } },
                          [
                            _c("el-input", {
                              attrs: { type: "text", id: "name", name: "name" },
                              model: {
                                value: _vm.formData.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "name", $$v)
                                },
                                expression: "formData.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.description") } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 3,
                                id: "description",
                                name: "description",
                              },
                              model: {
                                value: _vm.formData.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "description", $$v)
                                },
                                expression: "formData.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.insertZoneModal = false
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("general.cancel")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !_vm.formData.code,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.submitForm.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("general.insert")) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                staticClass: "responsive",
                attrs: {
                  visible: _vm.uploadZoneModal,
                  title: _vm.$t("zone.uploadZone"),
                  width: "50%",
                  top: "30vh",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.uploadZoneModal = $event
                  },
                },
              },
              [
                _vm.uploadZoneModal
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              "label-position": "top",
                              "label-width": "8em",
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "line", attrs: { md: 6, xs: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "pr-2",
                                    attrs: {
                                      label: _vm.$t("zone.projectCode"),
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "uppercase",
                                      attrs: {
                                        type: "text",
                                        id: "projectCode",
                                        name: "projectCode",
                                        disabled: true,
                                      },
                                      model: {
                                        value: _vm.projectCodeId,
                                        callback: function ($$v) {
                                          _vm.projectCodeId = $$v
                                        },
                                        expression: "projectCodeId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "line",
                                attrs: { md: 12, xs: 24 },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { staticClass: "pr-2 pl-2" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("zone.dataSet")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "file-container" },
                                      [
                                        _c("input", {
                                          ref: "dataSet",
                                          attrs: {
                                            type: "file",
                                            id: "dataSet",
                                            name: "dataSet",
                                            accept:
                                              "text/csv, application/json",
                                          },
                                          on: { change: _vm.onDataSetChanges },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { staticClass: "line", attrs: { md: 6, xs: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          slot: "label",
                                          "hidden-xs": "",
                                        },
                                        slot: "label",
                                      },
                                      [_vm._v(" ")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "w-100",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.zoneUpload.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("general.upload")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "map-container zone-modal" },
                          [
                            _c("map-world", {
                              ref: "mapWorldUpload",
                              attrs: { locations: _vm.locations },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "span",
                      { staticClass: "error-text" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "exclamation-circle" },
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.$t("zone.uploadZoneWarning")) + " "
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.uploadZoneModal = false
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("general.cancel")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: _vm.uploadLocationList.length === 0,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.submitZoneUpload.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("general.update")) + " ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-dialog",
              {
                staticClass: "responsive",
                attrs: {
                  visible: _vm.updateZoneModal,
                  title: _vm.$t("zone.updateZone"),
                  width: "50%",
                  top: "30vh",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.updateZoneModal = $event
                  },
                },
              },
              [
                _vm.updateZoneModal
                  ? _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "left",
                          "label-width": "8em",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.projectCode") } },
                          [
                            _c("el-input", {
                              staticClass: "uppercase",
                              attrs: {
                                type: "text",
                                id: "projectCode",
                                name: "projectCode",
                                disabled: true,
                              },
                              model: {
                                value: _vm.projectCodeId,
                                callback: function ($$v) {
                                  _vm.projectCodeId = $$v
                                },
                                expression: "projectCodeId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.code") } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 20 } },
                              [
                                _c("el-input", {
                                  staticClass: "uppercase",
                                  attrs: {
                                    type: "text",
                                    id: "code",
                                    name: "code",
                                  },
                                  model: {
                                    value: _vm.locationData.code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.locationData, "code", $$v)
                                    },
                                    expression: "locationData.code",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "center-text",
                                attrs: { span: 4 },
                              },
                              [
                                _c("el-color-picker", {
                                  attrs: { size: "medium" },
                                  model: {
                                    value: _vm.locationData.color,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.locationData, "color", $$v)
                                    },
                                    expression: "locationData.color",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.name") } },
                          [
                            _c("el-input", {
                              attrs: { type: "text", id: "name", name: "name" },
                              model: {
                                value: _vm.locationData.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.locationData, "name", $$v)
                                },
                                expression: "locationData.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.description") } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 3,
                                id: "description",
                                name: "description",
                              },
                              model: {
                                value: _vm.locationData.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.locationData, "description", $$v)
                                },
                                expression: "locationData.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.updateZoneModal = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !_vm.locationData.code,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.submitZoneInformation.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("general.update")) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                staticClass: "responsive",
                attrs: {
                  visible: _vm.copyZoneModal,
                  title: _vm.$t("zone.copyZone"),
                  width: "50%",
                  top: "30vh",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.copyZoneModal = $event
                  },
                },
              },
              [
                _vm.copyZoneModal
                  ? _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "left",
                          "label-width": "8em",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.projectCode") } },
                          [
                            _c("el-input", {
                              staticClass: "uppercase",
                              attrs: {
                                type: "text",
                                id: "projectCode",
                                name: "projectCode",
                                disabled: true,
                              },
                              model: {
                                value: _vm.projectCodeId,
                                callback: function ($$v) {
                                  _vm.projectCodeId = $$v
                                },
                                expression: "projectCodeId",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("zone.projectCode") } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  id: "copyProjectCode",
                                  name: "copyProjectCode",
                                  placeholder: _vm.$t("zone.selectProject"),
                                },
                                model: {
                                  value: _vm.copyProjectCodeId,
                                  callback: function ($$v) {
                                    _vm.copyProjectCodeId = $$v
                                  },
                                  expression: "copyProjectCodeId",
                                },
                              },
                              _vm._l(_vm.projectCodes, function (list) {
                                return _c("el-option", {
                                  key: list["ProjectCode"],
                                  attrs: {
                                    value: list["ProjectCode"],
                                    label: list["ProjectCode"],
                                    disabled:
                                      list["ProjectCode"] === _vm.projectCodeId,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.copyZoneModal = false
                            _vm.copyProjectCodeId = ""
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: !_vm.copyProjectCodeId,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.submitCopyForm.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("general.copy")) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "floating-box-zone" },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      {
                        staticClass: "d-none d-sm-block",
                        attrs: { xs: 24, sm: 24, md: 3 },
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("zone.list")) + ":"),
                        ]),
                      ]
                    ),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 6 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100",
                            attrs: {
                              id: "projectCodes",
                              name: "projectCodes",
                              filterable: "",
                              placeholder: _vm.$t("zone.selectProject"),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onChangeProjectCodes($event)
                              },
                            },
                            model: {
                              value: _vm.projectCodeId,
                              callback: function ($$v) {
                                _vm.projectCodeId = $$v
                              },
                              expression: "projectCodeId",
                            },
                          },
                          _vm._l(_vm.projectCodes, function (list) {
                            return _c("el-option", {
                              key: list["ProjectCode"],
                              attrs: {
                                value: list["ProjectCode"],
                                label: list["ProjectCode"],
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 10 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "w-100",
                            attrs: {
                              id: "locationList",
                              name: "locationList",
                              filterable: "",
                              disabled:
                                _vm.helper.isEmpty(_vm.projectCodeId) ||
                                _vm.locationList.length === 0,
                              placeholder: _vm.$t("zone.selectCode"),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onChangeLocation($event)
                              },
                            },
                            model: {
                              value: _vm.locationId,
                              callback: function ($$v) {
                                _vm.locationId = $$v
                              },
                              expression: "locationId",
                            },
                          },
                          _vm._l(_vm.locationList, function (list) {
                            return _c(
                              "el-option",
                              {
                                key: list["_id"],
                                attrs: {
                                  value: list["_id"],
                                  label: list["code"],
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(list["code"]))]),
                                _c("span", {
                                  staticClass: "select-color",
                                  style: {
                                    backgroundColor:
                                      list["_id"] !== ""
                                        ? list["color"]
                                        : "transparent",
                                  },
                                }),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 5 } },
                      [
                        _c(
                          "el-button-group",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.locationId === "",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.updateZone.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("zone.update")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { disabled: _vm.locationId === "" },
                                on: { click: _vm.deleteZone },
                              },
                              [_vm._v(_vm._s(_vm.$t("zone.delete")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.locationId != "" && _vm.locationId != null
              ? _c(
                  "div",
                  { staticClass: "floating-box-drawing" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          placement: "right",
                          content: _vm.$t("zone.edit"),
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "item-container",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.updateZoneModal = true
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "item-title",
                              attrs: { icon: "pen" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          placement: "right",
                          content: _vm.$t("zone.refresh"),
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "item-container",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.refreshMap()
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "item-title",
                              attrs: { icon: "undo" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.projectCodeId != "" && _vm.projectCodeId != null
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      placement: "left",
                      content: _vm.$t("zone.insert"),
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "round-button",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.insertZoneModal = true
                          },
                        },
                      },
                      [_c("span", { staticClass: "text" }, [_vm._v("+")])]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.projectCodeId != "" && _vm.projectCodeId != null
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      placement: "left",
                      content: _vm.$t("zone.upload"),
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "round-button file-upload",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.uploadZoneModal = true
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "file-upload" },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm.projectCodeId != "" && _vm.projectCodeId != null
              ? _c(
                  "el-tooltip",
                  {
                    attrs: { placement: "left", content: _vm.$t("zone.copy") },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "round-button copy-zone",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.copyZoneModal = true
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "copy" },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm.projectCodeId != "" && _vm.projectCodeId != null
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      placement: "left",
                      content: _vm.$t("zone.export"),
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "round-button file-export",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.exportZone.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "icon",
                          attrs: { icon: "file-download" },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _c("map-world", {
              ref: "mapWorld",
              attrs: {
                locations: _vm.locations,
                routes: _vm.locationList,
                "init-event": "polygon",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }